import { MILLISECONDS_IN_A_MINUTE, THIRTY_SECONDS_IN_MS } from 'constants/time';
import { useCallback, useEffect } from 'react';
import { getLocalStorage } from 'utils/localStorage';
import useToken, { TOKEN_EXPIRES_AT_KEY } from '../utils/token';

export type UseTokenRefreshProps = {
  isActive: boolean;
  onBeforeExpire: () => void;
};

export const useTokenExpiry = ({ isActive, onBeforeExpire }: UseTokenRefreshProps) => {
  const { token } = useToken();

  const refreshTokenCallback = useCallback(async () => {
    const expiresAt = getLocalStorage(TOKEN_EXPIRES_AT_KEY);
    if (!expiresAt || isNaN(+expiresAt)) {
      throw new Error('No Token available!');
    }

    // check if it's already time to refresh the token
    const now = new Date().getTime();
    if (now <= +expiresAt - MILLISECONDS_IN_A_MINUTE) {
      return;
    }

    onBeforeExpire();
  }, [onBeforeExpire]);

  useEffect(() => {
    if (isActive && token) {
      const interval = setInterval(refreshTokenCallback, THIRTY_SECONDS_IN_MS);
      return () => clearInterval(interval);
    }
    return;
  }, [isActive, token, refreshTokenCallback]);
};
